import React, { useState, useRef } from "react";
import { Card, Alert } from "react-bootstrap";
import WaveForm from "components/Question/Speaking/WaveForm";
import WaveFormRecorded from "components/MicSetup/WaveFormRecorded";

export default function StepThreeRecordVoice({
	setupProgress, recordedAudio, setRecordedAudio, setSetupProgress
}) {

	const [is_recording, setIsRecording] = useState(false);
	const [voiceDetected, setVoiceDetected] = useState(false);
	const [audioFinished, setAudioFinished] = useState(false);
	const mediaRecorderRef = useRef(null);
	const audioChunks = useRef([]);

	const startRecording = async () => {
		setIsRecording(true);
		const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
		mediaRecorderRef.current = new MediaRecorder(stream);
		audioChunks.current = [];

		mediaRecorderRef.current.ondataavailable = (e) => {
			audioChunks.current.push(e.data);
		};

		mediaRecorderRef.current.onstop = () => {
			const audioBlob = new Blob(audioChunks.current, { type: "audio/mp3" });
			const audioURL = URL.createObjectURL(audioBlob);
			setRecordedAudio(audioURL);
			
			// Stop stream tracks
			if (stream) {
				stream.getTracks().forEach(track => track.stop());
			}
		};

		mediaRecorderRef.current.start();
	};

	const stopRecording = (e) => {
		setIsRecording(false);

		if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
			mediaRecorderRef.current.stop();
			setVoiceDetected(true);
		}
	};

	const nextStep = () => {
		setSetupProgress(prev => ({
			...prev,
			stepFour: true
		}));
	};

	const selectAnotherDevice = () => {
		setRecordedAudio(null);
		setSetupProgress(prev => ({
			...prev,
			stepThree: false
		}));
	};

	return (
		<>
			{setupProgress.stepThree && !setupProgress.stepFour &&
				<>
					<Card className="p-4 mb-3 visibility-visible">
						<div className="sub-title mb-4">
							RECORD YOUR VOICE
						</div>

						<div className="sub-text mb-3">
							Please click start recording and read the text aloud. When finished reading, click on stop recording button.
						</div>

						<div className="mb-3 gray-text">
							In 2005, donor countries agreed on an accord to harmonize their practices. Since then, aid officials have complained that too little has
							changed on the ground. Conferences of donors in developing countries still tend to be dominated by a small group of north European
							governments, with the US often absent.
						</div>

						<div className="contact-form-btns mb-3">
							<button
								type="button"
								className="contact-save-btn btn m-0"
								onClick={startRecording}
								disabled={is_recording}
							>Start Recording</button>

							<button
								type="button"
								className="recording-buttons px-4 ms-3"
								onClick={stopRecording}
								disabled={!is_recording}
							>Stop</button>
						</div>

						<Alert color="danger" className="py-1 recording-note">
							Note: Please listen to the recording till the end by pressing to proceed.
						</Alert>

						{is_recording &&
							<WaveForm
								progressValue={15}
							/>
						}

						{!is_recording && recordedAudio &&
							<WaveFormRecorded
	                          testMode={false} 
	                          blobURL={recordedAudio}
	                          setAudioFinished={setAudioFinished}
	                        />
						}

						{audioFinished &&
							<div className="p-2 mt-3 ok-message">
								Your voice is strong enough for our A.I. to detect
							</div>
						}
					</Card>

					{audioFinished &&
						<Card className="p-4 contact-form-btns visibility-visible">
							<div className="row">
								<div className="col-6">
									<button
			                            onClick={selectAnotherDevice}
			                            className="contact-save-btn-alternative btn m-0 w-100"
			                        >
			                            Select Another Device
			                        </button>
			                    </div>
			                    <div className="col-6">
									<button
			                            onClick={nextStep}
			                            className="contact-save-btn btn m-0 w-100"
			                        >
			                            Voice is ok. Go to Next step
			                        </button>
			                    </div>
		                    </div>
						</Card>
					}
				</>
			}
		</>
	);
}